const API_ENDPOINT_URL = 'https://r7nbvydl49.execute-api.ap-southeast-2.amazonaws.com/v1';

export const config = {
    api: {
        invokeUrl: API_ENDPOINT_URL,
    },
};